<mat-dialog-content class="flex-display">
  <form #addressForm="ngForm">
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label for="address-search-input">Start typing gym studio name</mat-label>
      <input
        id="address-search-input"
        type="text"
        matInput
        aria-label="Search address"
        [matAutocomplete]="addressAutocomplete"
        [formControl]="addressSearchControl"
        placeholder="Start typing an address..." />
      <mat-autocomplete
        #addressAutocomplete="matAutocomplete"
        [displayWith]="displayPrediction"
        (optionSelected)="onAddressSelected($event.option.value)">
        @for (prediction of predictions$ | async; track prediction.placeId) {
          <mat-option [value]="prediction">
            {{ prediction.description }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <div class="address-info-popup">
      <gymfinder-address-info
        [address]="address"
        [editMode]="false"></gymfinder-address-info>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-raised-button (click)="closeDialog()">Close</button>

  <button
    [disabled]="!isResolved"
    (click)="confirmAddress()"
    mat-raised-button
    color="primary">
    Confirm
  </button>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</mat-dialog-actions>
